export default "__VITE_PUBLIC_ASSET__c5cc83e8__"